import Laborsaber from 'module/laborsaber/pages/Laborsaber';
import SchedulePage from 'module/schedule/pages/SchedulePage';
import SituationRoom from 'module/situationRoom/pages/SituationRoom';
import Setting from 'module/settings/Setting';
import { ROUTES } from '../enums/routes.enums';
import { INavigationItem } from '../interface/navigationItem.interface';
import HomePage from 'module/dashboard/HomePage';
import Broadcast from 'module/broadcast/Broadcast';
import NewSchedule from 'module/newSchedule/NewSchedule';
import Todo from 'module/toDoPage/Todo';
import AddToDo from 'module/toDoPage/TodoPages/addToDo/AddToDo';
import AddBroadcast from 'module/broadcast/AddBroadcast';
import ViewBroadcast from 'module/broadcast/ViewBroadcast';
import EditToDo from 'module/toDoPage/TodoPages/editToDo';
import EditToDoSchedule from 'module/toDoPage/TodoPages/editToDoSchedule/EditToDoSchedule';
import ViewToDoSchedule from 'module/toDoPage/TodoPages/viewToDoSchedule/ViewToDoSchedule';
import EditToDoScheduleEvent from 'module/toDoPage/TodoPages/scheduleEvent/EditToDoScheduleEvent';
import ViewToDoScheduleEvent from 'module/toDoPage/TodoPages/scheduleEvent/ViewToDoScheduleEvent';
import GetSingleTodo from 'module/toDoPage/TodoPages/getSingleToDo/GetSingleTodo';
import Scorecard from 'module/scorecard/Scorecard';
import GuestConnectContainer from 'module/guestconnect/page/GuestConnectContainer';
import GuestSentiment from 'module/guestconnect/page/GuestSentiment';
import Checklist from 'module/checklist/Checklist';
import Logbook from 'module/logBook/Logbook';
import AddShiftNotes from 'module/logBook/AddShiftNotes';
import ViewShiftNotes from 'module/logBook/ViewShiftNotes';
import Events from 'module/events/Events';
import CreateEvent from 'module/events/pages/CreateEvent';
import EventDetails from 'module/events/pages/EventDetails';
import CreateCustomer from 'module/customers/pages/CreateCustomer';
import GameMaster from 'module/gameMaster/GameMaster';
import {Onboarding} from 'module/onboarding/Onboarding';
import AddEmployeeNotes from 'module/logBook/AddEmployeeNotes';
import ViewEmployeeNotes from 'module/logBook/ViewEmployeeNotes';
import AddSalesAndTraffic from 'module/logBook/AddSalesAndTraffic';

export const managerNavigationItems: INavigationItem[] = [
	{
		path: ROUTES.HOMEPAGE,
		label: 'Home',
		contentComponent: HomePage,
	},
	{
		path: ROUTES.SCORECARD,
		label: 'Scroecard',
		contentComponent: Scorecard,
	},
	{
		path: ROUTES.GUESTCONNECT,
		label: 'Guest Connect',
		contentComponent: GuestConnectContainer,
	},
	{
		path: ROUTES.GUESTCONNECTSENTIMENT,
		label: 'Guest Sentiment',
		contentComponent: GuestSentiment,
	},
	{
		path: ROUTES.CHECKLIST,
		label: 'Checklist',
		contentComponent: Checklist,
	},
	{
		path: ROUTES.LOGBOOK,
		label: 'Logbook',
		contentComponent: Logbook,
	},
	{
		path: ROUTES.CREATE_EVENT,
		label: 'Create Event',
		contentComponent: CreateEvent,
	},
	{
		path: ROUTES.EVENT_DETAILS,
		label: 'Event Details',
		contentComponent: EventDetails,
	},
	{
		path: ROUTES.CREATE_CUSTOMER,
		label: 'Create Customer',
		contentComponent: CreateCustomer,
	},
	{
		path: ROUTES.EDIT_CUSTOMER,
		label: 'Edit Customer',
		contentComponent: CreateCustomer,
	},
	{
		path: ROUTES.EVENTS,
		label: 'Events',
		contentComponent: Events,
	},
	{
		path: ROUTES.GAMEMASTER,
		label: 'Game Master',
		contentComponent: GameMaster,
	},
	{
		path: ROUTES.HYPERSCHEDULER,
		label: 'Hyperscheduler',
		contentComponent: SchedulePage,
	},
	{
		path: ROUTES.BROADCAST,
		label: 'Broadcast',
		contentComponent: Broadcast,
	},
	{
		path: ROUTES.ADD_BROADCAST,
		label: 'Broadcast',
		contentComponent: AddBroadcast,
	},
	{
		path: ROUTES.EDIT_BROADCAST,
		label: 'Broadcast',
		contentComponent: AddBroadcast,
	},
	{
		path: ROUTES.VIEW_BROADCAST,
		label: 'Broadcast',
		contentComponent: ViewBroadcast,
	},
	{
		path: ROUTES.SCHEDULE,
		label: 'Schedule',
		contentComponent: NewSchedule,
	},

	{
		path: ROUTES.TO_DO_ID,
		label: 'To Do',
		contentComponent: GetSingleTodo,
	},
	{
		path: ROUTES.TO_DO,
		label: 'Get To Do BY ID',
		contentComponent: Todo,
	},
	{
		path: ROUTES.ADD_TO_DO,
		label: 'Add To Do',
		contentComponent: AddToDo,
	},
	{
		path: ROUTES.EDIT_TO_DO,
		label: 'Edit To Do',
		contentComponent: EditToDo,
	},
	{
		path: ROUTES.EDIT_TO_DO_SCHEDULE,
		label: 'Edit Recurring To Do',
		contentComponent: EditToDoSchedule,
	},
	{
		path: ROUTES.VIEW_TO_DO_SCHEDULE,
		label: 'View Recurring To Do',
		contentComponent: ViewToDoSchedule,
	},
	{
		path: ROUTES.VIEW_TO_DO_SCHEDULE_EVENT,
		label: 'View Recurring To-Do Occurrence',
		contentComponent: ViewToDoScheduleEvent,
	},
	{
		path: ROUTES.EDIT_TO_DO_SCHEDULE_EVENT,
		label: 'Edit Recurring To-Do Occurrence',
		contentComponent: EditToDoScheduleEvent,
	},

	{
		path: ROUTES.SITUATION_ROOM,
		label: 'Situation room',
		contentComponent: SituationRoom,
	},
	{
		path: ROUTES.LABORSABER,
		label: 'Laborsaber',
		contentComponent: Laborsaber,
	},
	{
		path: ROUTES.SETTINGS,
		label: 'Settings',
		contentComponent: Setting,
	},
	{
		path: ROUTES.ADD_SHIFT_NOTES,
		label: 'Add Shift Notes',
		contentComponent: AddShiftNotes,
	},
	{
		path: ROUTES.EDIT_SHIFT_NOTES,
		label: 'Edit Shift Notes',
		contentComponent: AddShiftNotes,
	},
	{
		path: ROUTES.VIEW_SHIFT_NOTES,
		label: 'View Shift Notes',
		contentComponent: ViewShiftNotes,
	},
	{
		path: ROUTES.ADD_EMPLOYEE_NOTES,
		label: 'Add Employee Notes',
		contentComponent: AddEmployeeNotes,
	},
	{
		path: ROUTES.EDIT_EMPLOYEE_NOTES,
		label: 'Edit Employee Notes',
		contentComponent: AddEmployeeNotes,
	},
	{
		path: ROUTES.VIEW_EMPLOYEE_NOTES,
		label: 'View Employee Notes',
		contentComponent: ViewEmployeeNotes,
	},
	{
		path: ROUTES.ADD_SALES_TRAFFIC_NOTES,
		label: 'Add Sales And Traffic',
		contentComponent: AddSalesAndTraffic,
	},
		{
		path: ROUTES.ONBOARDING,
		label: 'Onboarding',
		contentComponent: Onboarding,
	},
];
